import type { Tag, TextExtractionData } from '@carboncopyco/types';
import { mainApi } from './mainApi';

type AddTextractedTextArgs = {
  organizationId: string;
  entityType: string;
  entityId: string;
  revisionId: string;
  extractedContent: TextExtractionData['extractedContent'];
};

type ExtractedTextCSVArgs = {
  organizationId: string;
  entityType: string;
  entityId: string;
  revisionId: string;
};

type SignedUrlResponse = {
  signedUrl: string;
};

type IsEmptyResponse = {
  isEmpty: boolean;
};

export const textExtractionApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    addExtractedText: builder.mutation<Tag, AddTextractedTextArgs>({
      query: ({
        organizationId,
        entityType,
        entityId,
        revisionId,
        extractedContent,
      }) => {
        return {
          url: `/api/${organizationId}/recording-dataset/${entityType}/${entityId}/${revisionId}/add`,
          method: 'PUT',
          body: { data: extractedContent },
        };
      },
      invalidatesTags: ['TextExtractionIsCSVEmpty'],
    }),
    getExtractedTextCSV: builder.query<SignedUrlResponse, ExtractedTextCSVArgs>(
      {
        query: ({ organizationId, entityType, entityId, revisionId }) => ({
          url: `/api/${organizationId}/recording-dataset/${entityType}/${entityId}/${revisionId}/csv`,
          method: 'GET',
        }),
      }
    ),
    checkIsExtractedTextCSVEmpty: builder.query<
      IsEmptyResponse,
      ExtractedTextCSVArgs
    >({
      query: ({ organizationId, entityType, entityId, revisionId }) => ({
        url: `/api/${organizationId}/recording-dataset/${entityType}/${entityId}/${revisionId}/is-empty`,
        method: 'GET',
      }),
      providesTags: ['TextExtractionIsCSVEmpty'],
    }),
  }),
});

export const {
  useAddExtractedTextMutation,
  useLazyGetExtractedTextCSVQuery,
  useCheckIsExtractedTextCSVEmptyQuery,
} = textExtractionApi;
